var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    {
      staticClass:
        "page__heading bg-primary text-white text-center py-5 justify-content-center"
    },
    [
      _c("div", { staticClass: "content__column" }, [
        _c("p", { staticClass: "text-small text-uppercase opacity-50" }, [
          _vm._v(
            "\n      " +
              _vm._s(_vm.question.category.partLabel) +
              " —\n      " +
              _vm._s(
                _vm.__("qna.category.questionRange", [
                  _vm.question.category.questionRange
                ])
              ) +
              "\n    "
          )
        ]),
        _vm._v(" "),
        _c("h1", { staticClass: "font-weight-700 mb-5" }, [
          _vm._v(_vm._s(_vm.question.title))
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showAnswer,
                expression: "showAnswer"
              }
            ],
            staticClass: "anwser text-left mb-5"
          },
          [
            !_vm.isModeForChildren
              ? _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.question.answerAdults) }
                })
              : _c("span", {
                  domProps: { innerHTML: _vm._s(_vm.question.answerChildren) }
                })
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "toggle-answer" }, [
          _c(
            "div",
            {
              staticClass: "toggle-answer__handle",
              on: {
                click: function($event) {
                  _vm.showAnswer = !_vm.showAnswer
                }
              }
            },
            [
              _c("i", {
                staticClass: "fa toggle-answer__icon",
                class: {
                  "fa-chevron-up": _vm.showAnswer,
                  "fa-chevron-down": !_vm.showAnswer
                },
                attrs: { "aria-hidden": "true" }
              }),
              _c("br"),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "toggle-answer__label" },
                [
                  !_vm.showAnswer
                    ? [_vm._v(_vm._s(_vm.__("qna.label.answer.show")))]
                    : [_vm._v(_vm._s(_vm.__("qna.label.answer.hide")))]
                ],
                2
              )
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "bible-vers" }, [
          !_vm.isModeHSV
            ? _c("span", {
                domProps: { innerHTML: _vm._s(_vm.question.bibleVerseSv) }
              })
            : _c("span", {
                domProps: { innerHTML: _vm._s(_vm.question.bibleVerseHsv) }
              }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("span", {
            staticClass: "vers",
            domProps: { innerHTML: _vm._s(_vm.question.vers) }
          })
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }